import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.5562 14.973L10.6369 16.8924C9.92002 17.6092 8.94466 18.0215 7.91959 18.0139C6.89451 18.0064 5.91321 17.6032 5.18554 16.8524C4.43468 16.1247 4.03149 15.1432 4.02396 14.1183C4.01625 13.07 4.40525 12.1177 5.1221 11.4009L7.04148 9.48149M9.44622 7.02985L11.3656 5.11048C12.0824 4.39364 13.0578 3.98142 14.0829 3.98895C15.1079 3.99649 16.0892 4.39969 16.8169 5.15054C17.5444 5.87799 17.9476 6.85934 17.9551 7.88441C17.9627 8.90949 17.5738 9.88498 16.857 10.6019L14.9376 12.5212M8.14194 13.9121L13.9001 8.15393",
  stroke: "white",
  "stroke-width": "1.83333",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }